export const AutomotivoIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3335 7.5L16.1501 8.33333"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.85841 8.33333L1.66675 7.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2083 11.6667H13.125"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.87508 11.6667H4.79175"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1493 8.33337L15.4501 4.99004C15.2476 4.02504 14.3968 3.33337 13.4101 3.33337H6.67679C5.70929 3.33337 4.86846 4.00004 4.64846 4.94254L3.85596 8.33337"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.70841 16.6667H4.58341C5.27341 16.6667 5.83341 16.1067 5.83341 15.4167V14.5834H14.1667V15.4167C14.1667 16.1067 14.7267 16.6667 15.4167 16.6667H17.2917C17.8667 16.6667 18.3334 16.2 18.3334 15.625V10.8334C18.3334 9.45254 17.2142 8.33337 15.8334 8.33337H4.16675C2.78591 8.33337 1.66675 9.45254 1.66675 10.8334V15.625C1.66675 16.2 2.13341 16.6667 2.70841 16.6667Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
